import { Github, Mail } from 'lucide-react';
import VersionTracker from './VersionTracker';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 mt-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/Autar_logo_256x256.png"
                alt="Autar Logo"
                className="h-8 w-8 rounded-full"
              />
              <span
                className="text-xl font-semibold"
                style={{ color: 'var(--color-text-primary)' }}
              >
                Autar
              </span>
            </div>
            <p className="mb-4 max-w-md" style={{ color: 'var(--color-text-secondary)' }}>
              Autonomous code maintenance for legacy and modern code bases. Autar automates
              refactoring and enforces enterprise standards across every repository.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/autar"
                className="transition-colors focus-ring rounded-lg p-1 hover:text-teal-600 dark:hover:text-teal-400"
                style={{ color: 'var(--color-text-tertiary)' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href="https://x.com/autar_ai"
                className="transition-colors focus-ring rounded-lg p-1 hover:text-teal-600 dark:hover:text-teal-400"
                style={{ color: 'var(--color-text-tertiary)' }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="mailto:hello@autar.ai"
                className="transition-colors focus-ring rounded-lg p-1 hover:text-teal-600 dark:hover:text-teal-400"
                style={{ color: 'var(--color-text-tertiary)' }}
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3
              className="text-sm font-semibold mb-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Product
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://autar.ai/solutions"
                  className="transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                  style={{ color: 'var(--color-text-secondary)' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Features
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3
              className="text-sm font-semibold mb-4"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Company
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://autar.ai/about"
                  className="transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                  style={{ color: 'var(--color-text-secondary)' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="https://autar.ai/careers"
                  className="transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                  style={{ color: 'var(--color-text-secondary)' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@autar.ai"
                  className="transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                  style={{ color: 'var(--color-text-secondary)' }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 dark:border-slate-700/50 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <p className="text-sm" style={{ color: 'var(--color-text-tertiary)' }}>
                © {new Date().getFullYear()} Autar. All rights reserved.
              </p>
              <VersionTracker />
            </div>
            <div className="flex space-x-6">
              <a
                href="https://autar.ai/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                style={{ color: 'var(--color-text-secondary)' }}
              >
                Privacy Policy
              </a>
              <a
                href="https://autar.ai/terms"
                className="text-sm transition-colors focus-ring rounded px-1 py-0.5 hover:text-teal-600 dark:hover:text-teal-400"
                style={{ color: 'var(--color-text-secondary)' }}
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
